// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commission-rates-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: hidden;
}

.navigation-arrow {
  font-size: 2.5rem;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Settings/AccountsAndBilling/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".commission-rates-container {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: hidden;\n}\n\n.navigation-arrow {\n  font-size: 2.5rem;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
